module.exports = __webpack_public_path__ + "img/sr-onboarding-slides.b7c08333.png";